module.exports = __webpack_public_path__ + "static/magic-guide-33fa714fd9c5ea6749c867ea2a2878e7.png";